export default __webpack_public_path__ + "static/media/Hopscotch.5f446535.webp";